/* DINOTY: "Add to cart" on the home product cards ([data-dn-add]). Adds one unit through the Ajax cart API,
   then fires the theme's own cart:update event so the header count and the cart drawer refresh. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dn-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.classList.add('is-loading');
    var body = { items: [{ id: Number(btn.dataset.variant), quantity: 1 }] };
    var ids = sectionIds();
    if (ids.length) body.sections = ids.join(',');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) { btn.textContent = res.description || res.message; setTimeout(function () { btn.textContent = label; }, 2500); return; }
        btn.classList.add('is-done');
        btn.textContent = btn.dataset.added || '✓';
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: {}, sourceId: 'dn-card', data: { source: 'dn-card', itemCount: 1, variantId: String(btn.dataset.variant), sections: res.sections } };
        btn.dispatchEvent(ev);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });
})();
